import { API_URL } from '../environments/environment';

export const END_POINT = {
  FILE_UPLOAD: `${API_URL}:7878/servicios/aws/upload`,
  GET_DETAIL_FILE: `${API_URL}:7878/reportes/getConversation`,
  GET_FILES: `${API_URL}:7878/reportes/getGrabaciones`,
  GET_FILES_REPORT: `${API_URL}:7878/reportes/getGrabacionesZip`,
  ANALYZE_TEXT: `${API_URL}:3012/analyze-text`,
  DELETE_CONVERSATION: `${API_URL}:7878/reportes/deleteConversation`,
  ANALYZE_SENTIMENTS: `${API_URL}:7878/servicios/aws/analizer/sentiment`,
  ANALYZE_ENTITIES: `${API_URL}:7878/servicios/aws/analizer/entities`,
  ANALYZE_PHRASES: `${API_URL}:7878/servicios/aws/analizer/phrases`,
  USERS: {
    LOGIN: `${API_URL}:7878/usuarios/login`,
    LIST: `${API_URL}:7878/usuarios/getUsuarios`,
    GET_ONE: `${API_URL}:7878/usuarios/getUsuarios`,
    EDIT: `${API_URL}:7878/usuarios/updateUsuario`,
    DELETE: `${API_URL}:7878/usuarios/deleteUsuario`,
    ADD: `${API_URL}:7878/usuarios/addUsuario`,
    DEACTIVE_USER: `${API_URL}:7878/usuarios/deactivateUsuario`,
    ACTIVE_USER: `${API_URL}:7878/usuarios/activateUsuario`,
    ADD_MINUTES: `${API_URL}:7878/usuarios/addMinutesUsuario`,
    GET_MINUTES: `${API_URL}:7878/usuarios/getMinutes/`,
    RECOVER_PASSWORD: `${API_URL}:7878/usuarios/recoverPassword`,
    CHANGE_PASSWORD: `${API_URL}:7878/usuarios/recoverPassword2fA`,
    GET_CONSUMPTION: `${API_URL}:7878/usuarios/getConsumption`,
    VALIDATE_HASH_RECOVER_PASSWORD: `${API_URL}:7878/usuarios/resetPassword/`,
    RESET_MINUTES: `${API_URL}:7878/usuarios/resetMinutesUsuario`,
  },
  AREAS: {
    LIST: `${API_URL}:7878/areas/getAreas`,
    SAVE: `${API_URL}:7878/areas/addArea`,
    EDIT: `${API_URL}:7878/areas/editArea`,
    DELETE: `${API_URL}:7878/areas/deleteArea`,
  },
  PROFILES: {
    LIST: `${API_URL}:7878/perfiles/getPerfiles`,
    DELETE: `${API_URL}:7878/perfiles/deletePerfil`,
    SAVE: `${API_URL}:7878/perfiles/addPerfil`,
    UPDATE: `${API_URL}:7878/perfiles/editPerfil`,
  },
  MODULES: {
    LIST: `${API_URL}:7878/modulos/getModulos`,
  },
  CEDULAS: {
    GET_ALL: `${API_URL}:3012/analyze/cedulas/get-all`,
    GET_BY_ID: `${API_URL}:3012/analyze/cedulas/get-by-id`,
    SAVE: `${API_URL}:3012/analyze/cedulas/add`,
    UPDATE: `${API_URL}:3012/analyze/cedulas/update`,
    DELETE: `${API_URL}:3012/analyze/cedulas/delete`,
  },
  RUBRICAS: {
    SAVE: `${API_URL}:3012/analyze/rubricas/add`,
    UPDATE: `${API_URL}:3012/analyze/rubricas/update`,
    DELETE: `${API_URL}:3012/analyze/rubricas/delete`,
    GET_BY_CID: `${API_URL}:3012/analyze/rubricas/get-all`,
  },
  DASHBOARD: {
    GET: `${API_URL}:7878/reportes/dashboard`,
  },
  REPORTS: {
    GET: `${API_URL}:7878/reportes/getReportEjecutive`,
  },
};
